import Sidebar from '../Sidebar/Sidebardigital';
import React, { useState } from 'react';

export default function Farmer() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [district, setDistrict] = useState("");
  const [description, setDescription] = useState("");

  const handleOnSubmit = async (e) => {
    e.preventDefault();
    let result = await fetch('https://gatisheelback.azurewebsites.net/register', {
      method: "post",
      body: JSON.stringify({ name, email, district, description }),
      headers: {
        'Content-Type': 'application/json'
      }
    }); 
    result = await result.json();
    console.warn(result);
    if (result) {
      alert("Data saved successfully");
      // Reset form fields after successful submission
      setName("");
      setEmail("");
      setDistrict("");
      setDescription("");
    }
  };

  return (
    <>
      <div className="row">
        <div className="col-2 custom-display">
          <Sidebar />
        </div>
        <div className="col-8 custom-width">
          <br /><br /><br />
          <h1>Register Farmer details</h1><br />
          <form>
            <input type="text" placeholder="Name" value={name} onChange={(e) => setName(e.target.value)} /><br /><br />
            <input type="text" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} /><br /><br />
            <input type="text" placeholder="District" value={district} onChange={(e) => setDistrict(e.target.value)} /><br /><br />
            <input type="text" placeholder="Description" value={description} onChange={(e) => setDescription(e.target.value)} /><br /><br />
            <button type="submit" onClick={handleOnSubmit}>Submit</button>
          </form>
          <br /><br />
        </div>
        <div className="col-2 custom-display">
          <Sidebar />
        </div>
      </div>
    </>
  );
};
